import React, {useState} from 'react';
import {
    getResponsableEmpleadoWithoutReserverdPeopleWordTypeAPI,
    reasignarFlujoDocumentoEmpleadoAPI,
} from "../../../../consumers/backendApisUrls";
import GenericModal from "../../../../components/modal/GenericModal";
import AsyncSelectInput from "../../../../components/Select/AsyncSelectInput";
import {useSubmitForm} from "../../../../hooks/useSubmitForm/useSubmitForm";

const ReasignarResponsable = ({toggleModal, refreshPage, idFlujoDocumentoEmpleado, nombreEmpleado, nombreEmpleadoResponsable}) => {
    const KEYS = ["IdEmpleado"];
    const SECTION_NAME = ["ReasignarResponsable"]

    const [selectedAprobador, setSelectedAprobador] = useState();
    
    const [submitForm] = useSubmitForm()

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let api = reasignarFlujoDocumentoEmpleadoAPI();
            let payload = getPayload();
            await submitForm(KEYS, api, payload, SECTION_NAME, successReasignarCallback)
        } catch (error) {
            console.error(error);
        }
    }

    const getPayload = () => {
        return {
            IdFlujoDocumentoEmpleado: idFlujoDocumentoEmpleado,
            IdEmpleado: selectedAprobador?.value
        }
    }

    const successReasignarCallback = () => {
        toggleModal();
        refreshPage();
    }

  return (
    <GenericModal showModal={toggleModal} titulo="Reasignar responsable" width="600px">
        <div className="modal-body">
            <form>
                <div className="form-row mb-1">
                    <div className="form-group col-sm-12">
                        <label className="modal-label mb-0">Empleado</label>
                        <input type="text" className="form-control" value={nombreEmpleado ?? ""} disabled/>
                    </div>
                </div>
                <div className="form-row mb-1">
                    <div className="form-group col-sm-12">
                        <label className="modal-label mb-0">Responsable</label>
                        <input type="text" className="form-control" value={nombreEmpleadoResponsable ?? ""} disabled/>
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-sm-12">
                        <label className="modal-label mb-0">Nuevo Responsable</label>
                        <AsyncSelectInput api={getResponsableEmpleadoWithoutReserverdPeopleWordTypeAPI} placeholder="Buscar nuevo responsable" handleSelectInputChange={(res) => setSelectedAprobador(res)}/>
                        <p className="ficha-form-input-validation-message" id={`ficha-edit-${SECTION_NAME}-IdEmpleado-validation-message`}></p>
                    </div>
                </div>
                <div className="modal-footer pl-0">
                    <div>
                    </div>
                    <div>
                    <button type="button" onClick={handleSubmit} className="generic-button-buscador">
                        Guardar
                    </button>
                    </div>
                </div>
            </form>
        </div>
    </GenericModal>
  )
}

export default ReasignarResponsable